import React from 'react';
import { Badge } from 'antd';
import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import BankReconciliationService from 'services/BankReconciliationService';
import { BANK_RECONCILIATION_ROLES } from 'constants/BankReconciliationConstant';

const REFRESH_INTERVAL = 5 * 60 * 1000;

const ReviewQueueBadge = () => {
    const { isAuth } = useAuth([BANK_RECONCILIATION_ROLES]);
    const { data } = useQuery({
        ...BankReconciliationService.getReviewCount(),
        enabled: isAuth,
        refetchInterval: REFRESH_INTERVAL,
        retry: false,
    });
    const count = data?.data?.info?.total || 0;

    if (!isAuth || count === 0) return null;
    return <Badge count={count} overflowCount={999} className="ml-2" />;
};

export default ReviewQueueBadge;
